import { ConfirmNumber } from "./ConfirmNumber";
import { Info } from "./Info";

const jshirregister = {
  ConfirmNumber,
  Info
}

export default jshirregister